export enum SearchTypes {
  Gene = 'gene',
  Drug = 'drug',
  Categories = 'categories',
}

export enum ResultTypes {
  Gene = 'gene',
  Drug = 'drug',
}
